/**
 * 专题模块
 **/

import {INIT_SUBJECT_LIST} from "@constants/action-type/subject-action-type";
import {subjectList} from "@api/course-api";
import {showError} from "@utils/msg";
import {CHANGE_SUBJECT_SELECTED} from "@constants/mutation-type/subject-mutation-type";

export default {
    namespaced: true,
    state: {
        subjectList: [],
        // -1 代表全部
        selectedSubjectId: -1.
    },
    getters: {
        searchSubjectList(state) {
            const subjectList = state.subjectList.concat();
            subjectList.unshift({
                subjectId: -1,
                subjectTitle: '全部专题'
            });
            return subjectList;
        },

    },
    mutations: {
        setSubjectList(state, payload) {
            state.subjectList = payload.subjectList;
        },
        [CHANGE_SUBJECT_SELECTED](state, payload) {
            if (payload.subjectId !== null && payload.subjectId !== undefined && payload.subjectId !== '')
                state.selectedSubjectId = payload.subjectId;
        },

    },
    actions: {
        [INIT_SUBJECT_LIST]({commit}) {
            subjectList(1).then((res) => {
                if (res.code === 0) {
                    const subjectList = res.rows;
                    commit('setSubjectList', {
                        subjectList
                    })
                } else {
                    showError("获取专题列表出错", res.msg)
                }
            });
        }
    }
}
